if (!customElements.get('wls-cart-handler')) {
  customElements.define(
    'wls-cart-handler',
    class WLSCartHandler extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector('form');
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              const errorMessage = response.description || response.message;
              throw new Error(errorMessage);
            }

            // Update cart data if available
            const cartDataScript = document.getElementById('CartData');
            if (cartDataScript) {
              const cartData = JSON.parse(cartDataScript.textContent);
              const existingItem = cartData.items.find((item) => item.id === response.id);
              if (existingItem) {
                existingItem.quantity = response.quantity;
              } else {
                cartData.items.push(response);
              }
              cartDataScript.textContent = JSON.stringify(cartData);
            }

            // Update cart UI
            if (this.cart) {
              this.cart.renderContents(response);
              if (this.cart.classList.contains('is-empty')) {
                this.cart.classList.remove('is-empty');
              }
            }

            // Publish cart update event
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              cartData: response,
            });
          })
          .catch((error) => {
            console.error('Error:', error);
            // Handle error display if needed
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            if (loadingSpinner) loadingSpinner.classList.add('hidden');
          });
      }
    }
  );
}
